import { FaUsers, FaChalkboardTeacher, FaUserGraduate, FaClock } from 'react-icons/fa';
import CountUp from 'react-countup';
import { useInView } from 'react-intersection-observer';

export default function JourneySoFar() {
  const { ref, inView } = useInView({ triggerOnce: true });

  return (
    <div ref={ref} className="my-14 mx-auto text-center max-w-[1200px] px-4">
      <h1 className="text-primary-color text-3xl md:text-5xl font-medium	 mb-12">
        <span className="text-secondary-color">Our Journey</span> So Far
      </h1>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
        {[
          { icon: <FaUsers />, count: 27000, label: "USERS AFFECTED", suffix: "+" },
          { icon: <FaChalkboardTeacher />, count: 290, label: "MENTORS", suffix: "+" },
          { icon: <FaUserGraduate />, count: 8000, label: "MENTEES", suffix: "+" },
          { icon: <FaClock />, count: 2700, label: "DURATION (HRS)", suffix: "Hrs" },
        ].map(({ icon, count, label, suffix }, idx) => (
          <div
            key={idx}
            className="relative w-full max-w-[250px] h-[300px] mx-auto bg-gradient-to-br from-blue-500 to-purple-500 rounded-lg shadow-lg p-6 text-white transform transition duration-300 hover:scale-105 hover:shadow-xl"
          >
            {/* Background Icon */}

            {/* Main Content */}
            <div
             className="relative z-10 h-[100%] flex flex-col justify-between">
              <div className="text-5xl mb-4">{icon}</div>
             <div>
             <div
             className="flex justify-center items-center text-[120px] text-white opacity-10 animate-pulse">
              {icon}
            </div>
             <h1 className="text-4xl font-extrabold tracking-tight mt-2">
                {inView ? (
                  <CountUp end={count} duration={2.5} separator="," suffix={suffix} />
                ) : (
                  count.toLocaleString() + suffix
                )}
              </h1>
              <h2 className="mt-2 text-lg font-medium tracking-wide">{label}</h2>
             </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
